import React from "react";
import { ArrowRight } from "lucide-react";
import { useScrollReveal } from "@/hooks/useScrollReveal";

// Import images
import residentialImage from "@/assets/images/residential.png";
import commercialImage from "@/assets/images/commercial.png";

export default function ResidentialCommercial() {
  const { ref, visible } = useScrollReveal();

  const scrollToQuote = () => {
    const el = document.getElementById("quote");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section ref={ref} className="grid grid-cols-1 md:grid-cols-2">
      {/* Residential */}
      <div
        className={`relative h-[420px] md:h-[560px] overflow-hidden group transition-all duration-700 ${
          visible ? "opacity-100" : "opacity-0"
        }`}
      >
        <img
          src={residentialImage}
          alt="Residential home with new concrete driveway"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[hsl(var(--navy))]/90 via-[hsl(var(--navy))]/40 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12">
          <h2 className="headline text-white text-3xl sm:text-4xl md:text-5xl mb-3">
            Residential Concrete
          </h2>
          <p className="text-white/80 text-sm sm:text-base leading-relaxed mb-5 max-w-md">
            Driveways, patios, sidewalks, slabs, foundations and concrete
            improvements for your home.
          </p>
          <button
            onClick={scrollToQuote}
            className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border-2 border-white/40 hover:bg-[hsl(var(--accent))] hover:border-[hsl(var(--accent))] text-white font-heading text-base tracking-wider px-6 py-3 rounded-sm transition-all focus-ring"
          >
            Residential Services
            <ArrowRight size={18} />
          </button>
        </div>
      </div>

      {/* Commercial */}
      <div
        className={`relative h-[420px] md:h-[560px] overflow-hidden group transition-all duration-700 delay-150 ${
          visible ? "opacity-100" : "opacity-0"
        }`}
      >
        <img
          src={commercialImage}
          alt="Commercial concrete slab pour"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[hsl(var(--navy))]/90 via-[hsl(var(--navy))]/40 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12">
          <h2 className="headline text-white text-3xl sm:text-4xl md:text-5xl mb-3">
            Commercial Concrete
          </h2>
          <p className="text-white/80 text-sm sm:text-base leading-relaxed mb-5 max-w-md">
            Dependable concrete solutions for contractors, businesses, facilities
            and commercial properties.
          </p>
          <button
            onClick={scrollToQuote}
            className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border-2 border-white/40 hover:bg-[hsl(var(--accent))] hover:border-[hsl(var(--accent))] text-white font-heading text-base tracking-wider px-6 py-3 rounded-sm transition-all focus-ring"
          >
            Commercial Services
            <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
}